import { forwardRef, type PropsWithChildren } from 'react';

import { type InputProps } from '@mui/material';
import Input from '@mui/material/Input';

import { useStyles } from 'components/inputs/styles';

export interface TMXInputProps extends InputProps {
  field?: {
    name: string;
    value: string;
  };
}

const TMXInput = forwardRef<HTMLInputElement, PropsWithChildren<TMXInputProps>>(
  ({ field, className, ...props }, ref) => {
    const { classes, cx } = useStyles();
    return (
      <Input
        {...props}
        {...field}
        ref={ref}
        disableUnderline
        className={cx(classes.root, className)}
        inputProps={{ className: classes.input, ...props.inputProps }}
      />
    );
  },
);

export default TMXInput;
